// 客户费率列表
import { HttpGetCusRateList } from '@/service/costbilling';
import TableList from "@components/templates/tablelist";
import { mapState, mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    EQ_orderStatus: null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            isSuper: this.$store.state.userinfo.isSuper
        };
    },
    methods: {
        ajaxRequest: HttpGetCusRateList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case 'add':
                    this.$router.push({
                        name: 'costbillingRateBillupdate',
                        params: { type: "add" },
                    });
                    break;
                case 'query':
                    var url = this.$router.resolve({
                        name: "costbillingRateBillupdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'edit':
                    this.$router.push({
                        name: 'costbillingRateBillupdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "export":
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/cost/costCustomerRate/export", this.formData,
                        {
                            executor: "request",
                            download: true,
                            method: 'post'
                        }
                    );
                    break;
            }
        },
        getOperateNodeMap(row) {
            // console.log(row)
            const { id, type, } = row;
            return [{
                label: '查看',
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: '编辑',
                show: true,
                params: id,
                operate: 'edit'
            },
            ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getBillTransferWarehouse', 'getCusproductList']),
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: this.$t('global.common.export', { defaultValue: "导出" }),
                    operate: "export",
                    theme: "success",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "组织",
                    key: 'EQ_customerOrgId',
                    show: true,
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "仓库",
                    key: 'EQ_warehouseId',
                    show: true,
                    tag: 'vSelect',
                    options: this.getBillTransferWarehouse,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "计费币种",
                    key: 'EQ_currency',
                    show: true,
                    tag: 'vSelect',
                    options: [
                        { value: 'USD', label: 'USD' }
                    ],
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "项目",
                    key: 'EQ_lineId',
                    more: true,
                    tag: 'vSelect',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    }
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: '操作',
                    maxWidth: 90,
                    render: this.getOperateNodes
                }, {
                    title: '组织',
                    key: 'customerOrgName',
                },
                {
                    title: '仓库',
                    key: 'orgWarehouseCode',
                },
                {
                    title: '项目',
                    key: 'lineCode',
                },
                {
                    title: '计费币种',
                    key: 'currency',
                    sortable: true
                }, {
                    title: '备注',
                    key: 'remark',

                }, {
                    title: '更新时间',
                    key: 'updatedAt',

                }];
        },
    },
};




